// extracted by mini-css-extract-plugin
export default {"Overview":"style_Overview__YluZr","nodata":"style_nodata__3yTwv","card":"style_card__pmmWn"};